import PropTypes from "prop-types";
import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

const CancelModal = ({ show, onCancelClick, onCloseClick, order }) => {
  const [reason, setReason] = useState(null);
  const [otherReason, setOtherReason] = useState("");
  const [message, setMessage] = useState("");
  const [OutStock, setOutStock] = useState(false);

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">Cancel and Refund</h5>
        <button
          onClick={onCloseClick}
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 ">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>
          <div className="mt-4 pt-2 fs-15">
            <p className="text-muted mb-0">
              <h5>
                If you cancel this order, then this customer order will get
                cancelled, and this customer will get a full refund
              </h5>
            </p>
          </div>
          <br />

          <label htmlFor="cancellationReason" className="form-label">
            Select a cancellation reason (internal):
          </label>
          <select
            required
            id="cancellationReason"
            className="form-select"
            defaultValue=""
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="" disabled>
              -- Select Reason --
            </option>
            <option value="0">Supplier Out of Stock</option>
            <option value="1"> Incorrect Item Received</option>
            <option value="2">Customer requested Cancellation</option>
            <option value="3"> Insufficient Quantity Received</option>
            <option value="4">Price Change</option>
            <option value="5">Other</option>
          </select>
          <div className="form-check mt-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="outStockCheckbox"
              checked={OutStock}
              onChange={(e) => setOutStock(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="outStockCheckbox">
              Mark as out of stock
            </label>
          </div>
          {reason === "5" && (
            <div className="mt-3">
              <label htmlFor="otherReason" className="form-label">
                Please specify the reason:
              </label>
              <input
                type="text"
                id="otherReason"
                className="form-control"
                onChange={(e) => setOtherReason(e.target.value)}
              />
            </div>
          )}
          <br />
          <label htmlFor="message" className="form-label">
            Message to customer:
          </label>
          <textarea
            required
            id="message"
            className="form-control"
            rows="3"
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Close
          </button>
          <button
            disabled={reason === null}
            type="button"
            className="btn w-sm btn-danger "
            id="send-record"
            onClick={() =>
              onCancelClick(
                order.ord_id,
                reason,
                otherReason,
                message,
                OutStock
              )
            } // This is the function that will be called when the button is clicked
          >
            Yes, Cancel it!
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

CancelModal.propTypes = {
  onCloseClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  show: PropTypes.any,
};

export default CancelModal;
